// Add your custom JS here.
( function( $ ) {




    var lastScrollTop = 0;

    $(window).on("scroll", function () {
        var st = $(this).scrollTop();

        // Add/remove 'down' class based on scroll direction
        if (st > lastScrollTop) {
            $('.site-header').addClass('down');
        } else {
            $('.site-header').removeClass('down');
        }
        lastScrollTop = st;

        // Add/remove 'scrolled' class based on scroll position
        if (st > 156) {
            $('.site-header').addClass('scrolled');
        } else {
            $('.site-header').removeClass('scrolled');
        }
    });


    // SMOOOTH SCROLLING
    $('a[href*="#"]').on('click', function(e) {

        // Check if the anchor link is for the current page
        if (this.pathname === window.location.pathname && this.hash) {
            e.preventDefault(); // Prevent default anchor behavior

            var target = $(this.hash);
            if (target.length) {
                // Disable smooth scrolling temporarily
                $('html').css('scroll-behavior', 'auto');

                // Scroll to the target element
                $('html, body').animate({
                    scrollTop: target.offset().top
                }, 1000, function() {
                    // Re-enable smooth scrolling after scrolling is complete
                    $('html').css('scroll-behavior', 'smooth');
                });
            }
        }
    });

    $(document).on('click', '.scrolldown-button', function(e) {
        e.preventDefault();

        window.scrollTo({
            top: window.scrollY + window.innerHeight,
            behavior: 'smooth'
        });
    });







    // $(document).on("click", "a", function(event) {
    //     // Check if the anchor has a target attribute set to "_blank"
    //     if ($(this).hasClass("notransition")) {
    //         return;
    //     }
    
    //     if ($(this).attr("target") === "_blank") {
    //         return; // Do nothing if it has target="_blank"
    //     }
    
    //     // Check if the anchor has a "tel:" or "mailto:" href
    //     var href = $(this).attr("href");
    //     if (!href || href.startsWith("tel:") || href.startsWith("mailto:")) {
    //         return; // Do nothing for tel: and mailto: links
    //     }
    
    //     // Check if the anchor has a "#" href
    //     if (href.indexOf('#') !== -1) {
    //         return; // Do nothing for "#" links, but allow them to work
    //     }
    
    //     // Prevent the default behavior of the anchor tag
    //     event.preventDefault();
    
    //     // Add the "active" class to the element with class "page-transition-in"
    //     $(".page-transition-in").addClass("active");
    
    //     // Delay navigation by 500 milliseconds
    //     setTimeout(function() {
    //         window.location.href = href;
    //     }, 300);
    // });
    
    // // Function to remove the "active" class from "page-transition-in" element
    // function removeActiveClass() {
    //     var element = document.querySelector('.page-transition-in');
    //     if (element) {
    //         element.classList.remove('active');
    //     }
    // }
    
    // // Execute the function on page load
    // window.addEventListener('load', removeActiveClass);
    
    // // Execute the function on pageshow event (including navigating back in Safari)
    // window.addEventListener('pageshow', removeActiveClass);







    // Trigger swiper
    // var teamSwiper = new Swiper(".diensten-swiper", {
    //     slidesPerView: "auto",
    //     spaceBetween: 16,
    //     autoplay: false,
    //     loop: false,
    //     breakpoints: {
    //         992: {
    //             spaceBetween: 40,
    //         }
    //     },
    // });









    // Select the iframe
    const iframe = document.getElementById('vimeoplayer');

    if (iframe) {
        // Initialize the Vimeo Player
        const player = new Vimeo.Player(iframe);

        // Play button click handler
        $(".playbutton").on("click", function () {
            player.play();
            $(".video-popup").addClass("active");
        });

        // Close button click handler
        $(".video-popup .close").on("click", function () {
            player.pause();
            $(".video-popup").removeClass("active");
        });
    } 





    $(".close-popup").on("click", function () {
        $(this).parent().fadeOut(150);
    });












    $(".faq-item").on("click", function () {
        $(this).children(".faq-answer").slideToggle(150);
        $(this).toggleClass("active");
    });





    $(".search-toggle").on("click", function () {
        $(".header-search").addClass("active");
        $(".search-field").focus();
        $(".primary-navigation, .headerbtns, .mega-dropdown, .menu-toggle").removeClass("active");
        $(".backdrop").addClass("active");
    });

    $(".search-close").on("click", function () {
        $(".header-search, .backdrop").removeClass("active");
    });

    $(".menu-icon").on("click", function () {
        $(".main-menu, .backdrop").toggleClass("active");
        $(this).toggleClass("active");
    });


    $(".backdrop").on("click", function () {
        $(".main-menu, .backdrop, .dropdown-container, .menu-icon, .mega-dropdown, .headerbtns, .primary-navigation, .menu-toggle").removeClass("active");
    });

    $(".has-over-dropdown, .dropdown-over-w3s").hover(
        function() {
            setTimeout(function() {
                $(".dropdown-over-w3s, .has-over-dropdown").addClass("active");
            }, 10);
        },
        function() {
            setTimeout(function() {
                $(".dropdown-over-w3s, .has-over-dropdown").removeClass("active");
            }, 10);
        }
    );
    
    $(".has-diensten-dropdown, .dropdown-codeflow").hover(
        function() {
            setTimeout(function() {
                $(".dropdown-codeflow, .has-diensten-dropdown").addClass("active");
            }, 10);
        },
        function() {
            setTimeout(function() {
                $(".dropdown-codeflow, .has-diensten-dropdown").removeClass("active");
            }, 10);
        }
    );

    $(".dropdown-container .back").click(
        function() {
            setTimeout(function() {
                $(".dropdown-container, .has-over-dropdown, .has-diensten-dropdown").removeClass("active");
            }, 20);
        }
    );

    $(".menu-toggle").on("click", function () {

        if ($(this).hasClass("active")) {
            $(".primary-navigation, .backdrop, .menu-toggle, .headerbtns").removeClass("active");
        } else {
            $(".primary-navigation, .backdrop, .menu-toggle, .headerbtns").addClass("active");
        }
    });

    $(".mega-dropdown .back").on("click", function() {
        setTimeout(function() {
            $(".mega-dropdown.active, .menu-item.active").removeClass("active");
        }, 30);
    });

    
    ////////////// GSAP STUFFFFFF////////////// GSAP STUFFFFFF////////////// GSAP STUFFFFFF
    gsap.registerPlugin(ScrollTrigger);
    // ScrollTrigger.normalizeScroll(true);





    




        // Select all headings within .fade-title-in
    const headings = document.querySelectorAll('.fade-title-in h1, .fade-title-in h2, .fade-title-in h3, .fade-title-in h4, .fade-title-in h5, .fade-title-in h6');

    headings.forEach((heading) => {
        // Normalize non-breaking spaces so words split correctly (WP often uses &nbsp;).
        const originalHTML = heading.innerHTML
            .replace(/&nbsp;|&#160;|&#xA0;/gi, ' ')
            .replace(/\u00a0/g, ' ');
        
        // Use a simple regex replacement to wrap words in spans
        // This preserves all existing tags and spaces
        const wrappedHTML = originalHTML.replace(/(\S+)(\s*)/g, function(match, word, space) {
            // Check if the word ends with punctuation that should be followed by a space before a tag
            const needsExtraSpace = word.match(/[.,;:!?]$/) && space === '' && 
                                (match.slice(match.length).trim().startsWith('<'));
            
            const extraSpace = needsExtraSpace ? ' ' : '';
            return `<span class="word-wrapper"><span class="word">${word}</span></span>${space}${extraSpace}`;
        });
        
        // Replace the heading content with wrapped HTML
        heading.innerHTML = wrappedHTML;
        
        // Special case: Add a space after punctuation before tags
        // This is a manual fix that addresses the specific issue
        heading.querySelectorAll('.word-wrapper').forEach(wrapper => {
            const word = wrapper.querySelector('.word');
            if (word && word.textContent.match(/[.,;:!?]$/) && 
                wrapper.nextSibling && 
                wrapper.nextSibling.nodeType === Node.ELEMENT_NODE &&
                !wrapper.nextSibling.textContent.startsWith(' ')) {
                // Insert a space after this wrapper
                wrapper.insertAdjacentText('afterend', ' ');
            }
        });
        
        // Animate the words on scroll
        const words = heading.querySelectorAll('.word');
        if (words.length > 0) {
            gsap.fromTo(
                words,
                { y: '100%', opacity: 0 }, // Start below and invisible
                {
                    y: '0%',
                    opacity: 1,
                    stagger: 0.05, // Delay between each word
                    duration: 0.6, // Duration for each word's animation
                    ease: 'power2.out',
                    scrollTrigger: {
                        trigger: heading, // Animate when this heading enters the viewport
                        start: 'top 80%', // Start animation when 80% of the viewport height
                        end: 'bottom 20%', // End animation within the viewport
                        toggleActions: 'play none none none', // Play animation once
                    },
                }
            );
        }
    });









    // Select all media items
    const mediaItems = document.querySelectorAll(".parallax>img, .parallax>video, .parallax>iframe");

    mediaItems.forEach((item) => {
        gsap.fromTo(
            item,
            { y: 50 }, // Start slightly down
            {
                y: -50, // Move slightly up
                ease: "none", // Linear parallax effect
                scrollTrigger: {
                    trigger: item, // Each media item triggers its own parallax
                    start: "top bottom", // Start when the item enters the viewport
                    end: "bottom top", // End when the item leaves the viewport
                    scrub: true, // Smoothly link animation to scroll
                },
            }
        );
    });




















    // Select all elements with the .fade-in-up class
    const fadeInElements = document.querySelectorAll(".fade-in-up");

    // Check if any .fade-in-up elements exist
    if (fadeInElements.length > 0) {
        fadeInElements.forEach((element) => {
            gsap.from(element, {
                opacity: 0,
                y: 50, // Slide-up effect
                duration: 1,
                ease: "power2.out",
                scrollTrigger: {
                    trigger: element,
                    start: "top 80%", // Start animation when the element's top reaches 80% of the viewport
                    toggleActions: "play none none reverse", // Play on scroll down, reverse on scroll up
                    once: false, // Set to true if the animation should trigger only once
                }
            });
        });
    }




    //// NEWS FILTERING
    // Handle clicks on "Alles" labels or checkboxes
    $(document).on('click', '.all, input.checkbox', function(e) {
        let checkbox;
        let filterGroup;
        
        // Determine if we clicked the label or the checkbox
        if ($(this).is('label')) {
            e.preventDefault(); // Prevent default label behavior with duplicate IDs
            checkbox = $(this).siblings('input.checkbox');
            filterGroup = $(this).closest('.filter-option');
        } else {
            checkbox = $(this);
            filterGroup = $(this).closest('.filter-option');
        }
        
        // Toggle checkbox state if we clicked the label
        if ($(this).is('label')) {
            checkbox.prop('checked', !checkbox.prop('checked'));
        }
        
        // If "Alles" is checked, uncheck all other checkboxes in this group
        if (checkbox.prop('checked')) {
            filterGroup.find('input.option').prop('checked', false);
        }
        
        $('#filter').trigger('change');
    });

    // Handle clicks on individual option checkboxes
    $(document).on('click', 'input.option', function() {
        const filterGroup = $(this).closest('.filter-option');
        
        // Find the "Alles" checkbox in this specific group
        const allCheckbox = filterGroup.find('input.checkbox');
        
        // If any option is checked, uncheck "Alles"
        if ($(this).prop('checked')) {
            allCheckbox.prop('checked', false);
        }
        
        // Check if any options are selected in this group
        const checkedOptions = filterGroup.find('input.option:checked').length;
        
        // If no options are selected, check "Alles"
        if (checkedOptions === 0) {
            allCheckbox.prop('checked', true);
        }
        
        $('#filter').trigger('change');
    });

    // Prevent the form from submitting on checkbox changes
    $('#filter').on('submit', function(e) {
        e.preventDefault();
    });






    

    // Function to animate countup elements
    if ($('.countup').length) {
        function initCountUp() {
        const countupElements = gsap.utils.toArray('.countup');
        
        countupElements.forEach(element => {
            // Get the original text content
            const originalText = element.textContent.trim();
            
            // Parse the text to extract number and any prefix/suffix
            const match = originalText.match(/^([^0-9]*)(\d+)(.*)$/);
            
            if (!match) return; // Skip if no number found
            
            const prefix = match[1]; // + or -
            const number = parseInt(match[2]);
            const suffix = match[3]; // % or other characters
            
            // Set initial value to 0
            element.textContent = prefix + '0' + suffix;
            
            // Create the animation
            const countUpAnimation = gsap.to(element, {
            duration: 2,
            ease: "power1.out",
            onUpdate: function() {
                const progress = this.progress();
                const currentValue = Math.round(number * progress);
                element.textContent = prefix + currentValue + suffix;
            },
            scrollTrigger: {
                trigger: element,
                start: "top 80%", // Start when element is 80% from top of viewport
                once: true, // Only animate once
            }
            });
        });
        }

        // Initialize on page load
        document.addEventListener('DOMContentLoaded', initCountUp);
    }










/**
 * Video Modal Functionality - Vimeo Only Version
 */
function initVideoModals() {
    // Get the modal elements
    const videoModal = document.getElementById('video-modal');
    const videoModalClose = document.getElementById('video-modal-close');
    const videoModalIframeContainer = document.getElementById('video-modal-iframe-container');
    
    if (!videoModal) return; // Exit if modal doesn't exist
    
    // Get all play buttons
    const videoPlayButtons = document.querySelectorAll('.video-play-button');
    
    // Add click event to all play buttons
    videoPlayButtons.forEach(button => {
        button.addEventListener('click', function() {
            const videoId = this.getAttribute('data-video-id');
            const videoUrl = this.getAttribute('data-video-url');
            
            // Create iframe
            const iframe = document.createElement('iframe');
            iframe.setAttribute('src', videoUrl);
            iframe.setAttribute('frameborder', '0');
            iframe.setAttribute('allow', 'autoplay; fullscreen');
            iframe.setAttribute('id', 'video-iframe-' + videoId);
            
            // Clear existing iframe and add new one
            videoModalIframeContainer.innerHTML = '';
            videoModalIframeContainer.appendChild(iframe);
            
            // Open modal
            videoModal.classList.add('active');
            
            // Prevent scrolling on body
            document.body.style.overflow = 'hidden';
        });
    });
    
    // Close modal when clicking the close button
    videoModalClose.addEventListener('click', closeModal);
    
    // Close modal when clicking outside the content
    videoModal.addEventListener('click', function(event) {
        if (event.target === videoModal) {
            closeModal();
        }
    });
    
    // Close modal with ESC key
    document.addEventListener('keydown', function(event) {
        if (event.key === 'Escape' && videoModal.classList.contains('active')) {
            closeModal();
        }
    });
    
    function closeModal() {
        // Remove active class
        videoModal.classList.remove('active');
        
        // Empty iframe container to stop video
        videoModalIframeContainer.innerHTML = '';
        
        // Restore scrolling
        document.body.style.overflow = '';
    }
}

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', initVideoModals);





    /**
     * Timeline Swiper Initialization
     * Creates a horizontal timeline with progress tracking
     */
    function initTimelineSliders() {
        // Find all timeline swiper containers
        const timelineContainers = document.querySelectorAll('.timeline__swiper');
        
        if (!timelineContainers.length) return;
        
        timelineContainers.forEach(container => {
            const sliderId = container.id;
            const prevButton = document.getElementById(sliderId + '-prev');
            const nextButton = document.getElementById(sliderId + '-next');
            const progressLine = document.getElementById(sliderId + '-progress');
            
            if (!sliderId || !prevButton || !nextButton || !progressLine) return;
            
            const timelineSwiper = new Swiper('#' + sliderId, {
                slidesPerView: 1,
                spaceBetween: 30,
                speed: 800,
                grabCursor: true,
                watchSlidesProgress: true,
                navigation: {
                    nextEl: '#' + sliderId + '-next',
                    prevEl: '#' + sliderId + '-prev',
                },
                on: {
                    init: function() {
                        updateTimelineProgress(this, progressLine);
                    },
                    slideChange: function() {
                        updateTimelineProgress(this, progressLine);
                    }
                }
            });
            
            function updateTimelineProgress(swiper, progressElement) {
                if (!progressElement) return;
                
                const totalSlides = swiper.slides.length;
                const activeIndex = swiper.activeIndex;
                const slidesPerView = swiper.params.slidesPerView;
                
                // Calculate progress percentage
                let progressPercent;
                if (totalSlides <= slidesPerView) {
                    progressPercent = 100; // Show full line if all slides visible
                } else {
                    const maxProgress = 1 - (slidesPerView / totalSlides);
                    progressPercent = (activeIndex / (totalSlides - slidesPerView)) * 100;
                    
                    // Ensure progress doesn't exceed 100%
                    progressPercent = Math.min(progressPercent, 100);
                }
                
                progressElement.style.width = progressPercent + '%';
            }
        });
    }

    // Initialize when DOM is ready
    document.addEventListener('DOMContentLoaded', initTimelineSliders);

    








        // Get all menu items that have dropdowns
    const menuItems = $('.menu-item.has-dropdown');
    const megaDropdowns = $('.mega-dropdown');
    const header = $('.site-header');
    const backDrop = $(".backdrop");
    
    // Set timeout variable for delayed removal
    let timeoutId;
    
    // Handle mouse enter on menu items
    menuItems.on('mouseenter', function() {
        // Clear any pending timeout
        clearTimeout(timeoutId);
        
        // Get the menu slug from this menu item
        const menuSlug = $(this).data('menu-slug');
        
        // Remove active class from all menu items and dropdowns first
        menuItems.removeClass('active');
        megaDropdowns.removeClass('active');
        
        // Add active class to this menu item
        $(this).addClass('active');
        backDrop.addClass('active');
        
        // Add active class to corresponding dropdown
        $(`.mega-dropdown[data-menu-slug="${menuSlug}"]`).addClass('active');
    });
    
    // Handle mouse leave on menu items
    menuItems.on('mouseleave', function() {
        // Don't close immediately, give a small delay to allow moving to dropdown
        timeoutId = setTimeout(function() {
            // Check if we're still outside the header before closing
            if (!header.is(':hover')) {
                menuItems.removeClass('active');
                megaDropdowns.removeClass('active');
                backDrop.removeClass('active');
            }
        }, 100);
    });
    
    // Handle mouse enter on dropdowns
    megaDropdowns.on('mouseenter', function() {
        // Clear any pending timeout
        clearTimeout(timeoutId);
        
        const menuSlug = $(this).data('menu-slug');
        
        // Add active class to corresponding menu item
        $(`.menu-item[data-menu-slug="${menuSlug}"]`).addClass('active');
        
        // Make sure this dropdown is active
        $(this).addClass('active');
    });
    
    // Handle mouse leave on dropdowns
    megaDropdowns.on('mouseleave', function() {
        menuItems.removeClass('active');
        megaDropdowns.removeClass('active');
        backDrop.removeClass('active');
    });
    
    // Close when clicking outside the header
    $(document).on('click', function(e) {
        if (!$(e.target).closest('.site-header').length) {
            menuItems.removeClass('active');
            megaDropdowns.removeClass('active');
            backDrop.removeClass('active');
        }
    });
    













/**
 * Text Scramble Effect for p.lead elements
 * Based on TextScramble class - triggers on load and scroll
 */

class TextScramble {
    constructor(el) {
        this.el = el;
        this.chars = '!<>-_\\/[]{}—=+*^?#________';
        this.update = this.update.bind(this);
    }
    
    scramble() {
        const text = this.el.textContent;
        const promise = new Promise((resolve) => this.resolve = resolve);
        this.queue = [];
        
        for (let i = 0; i < text.length; i++) {
            const char = text[i];
            const start = Math.floor(Math.random() * 40);
            const end = start + Math.floor(Math.random() * 40);
            this.queue.push({ 
                from: char, 
                to: char, 
                start, 
                end 
            });
        }
        
        cancelAnimationFrame(this.frameRequest);
        this.frame = 0;
        this.update();
        return promise;
    }
    
    update() {
        let output = '';
        let complete = 0;
        
        for (let i = 0, n = this.queue.length; i < n; i++) {
            let { from, to, start, end, char } = this.queue[i];
            
            if (this.frame >= end) {
                complete++;
                output += to;
            } else if (this.frame >= start) {
                if (!char || Math.random() < 0.28) {
                    char = this.randomChar();
                    this.queue[i].char = char;
                }
                output += `<span class="dud">${char}</span>`;
            } else {
                output += from;
            }
        }
        
        this.el.innerHTML = output;
        
        if (complete === this.queue.length) {
            this.resolve();
        } else {
            this.frameRequest = requestAnimationFrame(this.update);
            this.frame++;
        }
    }
    
    randomChar() {
        return this.chars[Math.floor(Math.random() * this.chars.length)];
    }
}

// Track animated elements
const animatedElements = new Set();

// Animate single element
function animateElement(element) {
    if (animatedElements.has(element)) return;
    animatedElements.add(element);
    
    const scrambler = new TextScramble(element);
    scrambler.scramble();
}

// Check if element is in viewport
function isInViewport(element) {
    const rect = element.getBoundingClientRect();
    return rect.top < window.innerHeight && rect.bottom > 0;
}

// Initialize scramble effects
function initScrambleEffects() {
    const elements = document.querySelectorAll('p.lead:not(.noani)');
    
    if (elements.length === 0) return;
    
    // Animate elements already in viewport
    elements.forEach((element, index) => {
        if (isInViewport(element)) {
            setTimeout(() => animateElement(element), index * 100);
        }
    });
    
    // Set up intersection observer for scroll-triggered animations
    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                setTimeout(() => animateElement(entry.target), Math.random() * 200);
                observer.unobserve(entry.target);
            }
        });
    }, {
        threshold: 0.1,
        rootMargin: '0px 0px -50px 0px'
    });
    
    elements.forEach(element => {
        if (!animatedElements.has(element)) {
            observer.observe(element);
        }
    });
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initScrambleEffects);
} else {
    initScrambleEffects();
}





/**
 * Font Size Toggle with Persistent State
 * Toggles large-font class on body and saves state
 */

class FontToggle {
    constructor() {
        this.storageKey = 'large-font-enabled';
        this.toggleButton = document.querySelector('.font-toggle');
        this.body = document.body;
        
        this.init();
    }
    
    init() {
        if (!this.toggleButton) {
            console.warn('Font toggle button not found');
            return;
        }
        
        // Load saved state on page load
        this.loadState();
        
        // Add click event listener
        this.toggleButton.addEventListener('click', () => {
            this.toggle();
        });
        
        // Update button appearance based on current state
        this.updateButtonState();
    }
    
    toggle() {
        const isLargeFontEnabled = this.body.classList.contains('large-font');
        
        if (isLargeFontEnabled) {
            this.body.classList.remove('large-font');
            this.saveState(false);
        } else {
            this.body.classList.add('large-font');
            this.saveState(true);
        }
        
        this.updateButtonState();
    }
    
    saveState(isEnabled) {
        try {
            localStorage.setItem(this.storageKey, isEnabled ? 'true' : 'false');
        } catch (error) {
            console.warn('Could not save font size preference:', error);
        }
    }
    
    loadState() {
        try {
            const savedState = localStorage.getItem(this.storageKey);
            if (savedState === 'true') {
                this.body.classList.add('large-font');
            } else {
                this.body.classList.remove('large-font');
            }
        } catch (error) {
            console.warn('Could not load font size preference:', error);
        }
    }
    
    updateButtonState() {
        const isLargeFontEnabled = this.body.classList.contains('large-font');
        
        // Add visual feedback to button
        if (isLargeFontEnabled) {
            this.toggleButton.classList.add('active');
            this.toggleButton.setAttribute('aria-pressed', 'true');
            this.toggleButton.title = 'Switch to normal font size';
        } else {
            this.toggleButton.classList.remove('active');
            this.toggleButton.setAttribute('aria-pressed', 'false');
            this.toggleButton.title = 'Switch to large font size';
        }
    }
}

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
    new FontToggle();
});

// Also initialize if script loads after DOM is ready
if (document.readyState !== 'loading') {
    new FontToggle();
}












    // Open sidebar when button with #sidebar-offices URL is clicked
    $('a[href="#sidebar-offices"], button[data-target="#sidebar-offices"]').on('click', function(e) {
        e.preventDefault();
        $('.sidebar-offices-back').addClass('active');
        
        // Optional: Add body class to prevent scrolling
        $('body').addClass('sidebar-open');
    });
    
    // Close sidebar when close button is clicked
    $('.sidebar-offices-back .close').on('click', function(e) {
        e.preventDefault();
        $('.sidebar-offices-back').removeClass('active');
        
        // Optional: Remove body class to restore scrolling
        $('body').removeClass('sidebar-open');
    });
    
    // Close sidebar when clicking the background (direct element only, not children)
    $('.sidebar-offices-back').on('click', function(e) {
        if (e.target === this) {
            $(this).removeClass('active');
            $('body').removeClass('sidebar-open');
        }
    });
    
    // Close sidebar on ESC key press
    $(document).on('keydown', function(e) {
        if (e.keyCode === 27 && $('.sidebar-offices-back').hasClass('active')) {
            $('.sidebar-offices-back').removeClass('active');
            $('body').removeClass('sidebar-open');
        }
    });




        // Use event delegation to handle all FAQ buttons with a single handler
    $(document).on('click', '.faq__question-button', function(e) {
        e.preventDefault();
        
        var $button = $(this);
        var $item = $button.closest('.faq__item');
        var $answer = $item.find('.faq__answer');
        var $icon = $button.find('.faq__question-icon i');
        var isExpanded = $button.attr('aria-expanded') === 'true';
        
        // Close all other FAQ items
        $('.faq__item').not($item).each(function() {
            var $otherButton = $(this).find('.faq__question-button');
            var $otherAnswer = $(this).find('.faq__answer');
            var $otherIcon = $(this).find('.faq__question-icon i');
            
            if ($otherButton.attr('aria-expanded') === 'true') {
                $otherAnswer.slideUp(300);
                $otherButton.attr('aria-expanded', 'false');
                $otherAnswer.attr('aria-hidden', 'true');
                $otherIcon.removeClass('icon-chevron-up').addClass('icon-chevron-down');
            }
        });
        
        // Toggle current FAQ item
        if (isExpanded) {
            $answer.slideUp(300);
            $button.attr('aria-expanded', 'false');
            $answer.attr('aria-hidden', 'true');
            $icon.removeClass('icon-chevron-up').addClass('icon-chevron-down');
        } else {
            $answer.slideDown(300);
            $button.attr('aria-expanded', 'true');
            $answer.attr('aria-hidden', 'false');
            $icon.removeClass('icon-chevron-down').addClass('icon-chevron-up');
        }
    });





    const casesSwiper = new Swiper('.all-cases .swiper', {
        slidesPerView: "auto",
        spaceBetween: 8,
        grabCursor: true,
        navigation: {
            nextEl: '.all-cases__nav--prev',
            prevEl: '.all-cases__nav--next',
        },
    });


    const swiper = new Swiper('.insights .swiper', {
        slidesPerView: "auto",
        spaceBetween: 24,
        navigation: {
            nextEl: '.insights__nav--next',
            prevEl: '.insights__nav--prev',
        },
        breakpoints: {
            768: {
                slidesPerView: 2,
            },
            1024: {
                slidesPerView: 3,
            }
        }
    });

    /**
     * Video Modal Functionality - Supports YouTube and Vimeo
     */
    
    // Main video component modal
    const videoModal = document.getElementById('video-modal');
    if (videoModal) {
        const videoModalClose = document.getElementById('video-modal-close');
        const videoModalIframeContainer = document.getElementById('video-modal-iframe-container');
        const videoPlayButtons = document.querySelectorAll('.video-play-button');

        videoPlayButtons.forEach(button => {
            button.addEventListener('click', function () {
                const videoId = this.getAttribute('data-video-id');
                const videoUrl = this.getAttribute('data-video-url');
                const videoType = this.getAttribute('data-video-type') || 'vimeo';

                const iframe = document.createElement('iframe');
                iframe.setAttribute('src', videoUrl);
                iframe.setAttribute('frameborder', '0');

                if (videoType === 'youtube') {
                    iframe.setAttribute('allow', 'autoplay; fullscreen; picture-in-picture');
                } else {
                    iframe.setAttribute('allow', 'autoplay; fullscreen');
                }

                iframe.setAttribute('id', 'video-iframe-' + videoId);

                videoModalIframeContainer.innerHTML = '';
                videoModalIframeContainer.appendChild(iframe);

                videoModal.classList.add('active');
                document.body.style.overflow = 'hidden';
            });
        });

        function closeVideoModal() {
            videoModal.classList.remove('active');
            videoModalIframeContainer.innerHTML = '';
            document.body.style.overflow = '';
        }

        videoModalClose.addEventListener('click', closeVideoModal);

        videoModal.addEventListener('click', function (event) {
            if (event.target === videoModal) {
                closeVideoModal();
            }
        });

        document.addEventListener('keydown', function (event) {
            if (event.key === 'Escape' && videoModal.classList.contains('active')) {
                closeVideoModal();
            }
        });
    }

    // Media component video modal
    const playButtons = document.querySelectorAll('.media__play-button');
    const mediaModal = document.getElementById('mediaVideoModal');
    if (mediaModal && playButtons.length > 0) {
        const modalClose = document.querySelector('.media__video-modal-close');
        const modalOverlay = document.querySelector('.media__video-modal-overlay');
        const iframe = document.getElementById('mediaVideoIframe');

        playButtons.forEach(button => {
            button.addEventListener('click', function() {
                const videoId = this.getAttribute('data-video-id');
                const videoType = this.getAttribute('data-video-type') || 'vimeo';
                let videoUrl = '';

                if (videoType === 'youtube') {
                    videoUrl = `https://www.youtube.com/embed/${videoId}?autoplay=1`;
                } else {
                    videoUrl = `https://player.vimeo.com/video/${videoId}?autoplay=1`;
                }

                iframe.src = videoUrl;

                if (videoType === 'youtube') {
                    iframe.setAttribute('allow', 'autoplay; fullscreen; picture-in-picture');
                } else {
                    iframe.setAttribute('allow', 'autoplay; fullscreen');
                }

                mediaModal.classList.add('is-active');
                document.body.style.overflow = 'hidden';
            });
        });

        function closeMediaModal() {
            mediaModal.classList.remove('is-active');
            iframe.src = '';
            document.body.style.overflow = '';
        }

        modalClose.addEventListener('click', closeMediaModal);
        modalOverlay.addEventListener('click', closeMediaModal);

        document.addEventListener('keydown', function(e) {
            if (e.key === 'Escape' && mediaModal.classList.contains('is-active')) {
                closeMediaModal();
            }
        });
    }


})(jQuery);

